import angular from 'angular';
import constants from 'app/constants';
import {
  amSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-agency-confirm-dialog.controller';
import template from './delete-agency-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, audit, agency, agencies, auditTypes, coordinators, dataTypes, refreshAudit
  }) {
    return {
      controller,
      controllerAs: 'deleteAgencyConfirmDialogVM',
      locals: {
        customerId,
        audit,
        agency,
        agencies,
        auditTypes,
        coordinators,
        dataTypes,
        refreshAudit
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.deleteAgencyConfirmDialog', [
  alerts,
  amSharedModelService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteAgencyConfirmDialog', dialogService)
  .name;
